import React, { useState, FormEvent } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    // Format the message for WhatsApp
    const whatsappMessage = `Name: ${formData.name}%0AEmail: ${formData.email}%0AMessage: ${formData.message}`;
    
    // Create WhatsApp URL with pre-filled message
    const whatsappUrl = `https://wa.me/919698862115?text=${whatsappMessage}`;
    
    // Open WhatsApp in a new tab
    window.open(whatsappUrl, '_blank');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 animated-section">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Contact Us</h2>
          <p className="text-lg text-muted-foreground">
            We'd love to hear from you. Reach out to us with any questions, 
            partnership opportunities, or to learn more about our work.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          <div className="animated-section">
            <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
              <h3 className="text-2xl font-semibold mb-6">Director Information</h3>
              
              <div className="flex mb-4">
                <div className="mr-4 p-2 rounded-full bg-primary/10 flex-shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="font-medium">Mr. Raffi. A</div>
                  <p className="text-muted-foreground">+91 9698862115</p>
                </div>
              </div>
              
              

              <div className="flex mt-4">
                <div className="mr-4 p-2 rounded-full bg-primary/10 flex-shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>   
                  <div className="font-medium">Mr. Munversheriff. A</div>
                  <p className="text-muted-foreground">+91 9087306340</p>
                </div>
              </div>

              <div className="flex mt-4">
                <div className="mr-4 p-2 rounded-full bg-primary/10 flex-shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>   
                  <div className="font-medium">Mr. Thamarai Selvam.T</div>
                  <p className="text-muted-foreground">+91 9629665932</p>
                </div>
              </div>
              
              <div className="flex mt-4">
                <div className="mr-4 p-2 rounded-full bg-primary/10 flex-shrink-0">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="font-medium">Address</div>
                  <p className="text-muted-foreground">
                    1/71 B, Perfect Garden,<br />
                    Andakkapalayam,<br /> Vellanipatti Post, Coimbatore,<br />
                    Tamil Nadu - 641048.
                  </p>
                </div>
              </div>
            </div>
          </div>

          

          <div className="animated-section">
            <form onSubmit={handleSubmit} className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
              <h3 className="text-2xl font-semibold mb-6">Send a Message</h3>
              
              <div className="mb-4">
                <label htmlFor="name" className="block text-sm font-medium mb-1">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background"
                  required
                />
              </div>
              
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-medium mb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background"
                  required
                />
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium mb-1">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background"
                  required
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full px-4 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-gray-900"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;